/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemRecordingFromJSON(json) {
    return WallItemRecordingFromJSONTyped(json, false);
}
export function WallItemRecordingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'downloadUrl': !exists(json, 'download_url') ? undefined : json['download_url'],
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'previewStorageUrl': !exists(json, 'preview_storage_url') ? undefined : json['preview_storage_url'],
        'recordingStatus': !exists(json, 'recording_status') ? undefined : json['recording_status'],
    };
}
export function WallItemRecordingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'download_url': value.downloadUrl,
        'storage_url': value.storageUrl,
        'preview_storage_url': value.previewStorageUrl,
        'recording_status': value.recordingStatus,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemRecordingRecordingStatus;
(function (WallItemRecordingRecordingStatus) {
    WallItemRecordingRecordingStatus["NONE"] = "RECORDING_STATUS_NONE";
    WallItemRecordingRecordingStatus["PAUSED"] = "RECORDING_STATUS_PAUSED";
    WallItemRecordingRecordingStatus["RESUMED"] = "RECORDING_STATUS_RESUMED";
    WallItemRecordingRecordingStatus["TEMPORARYFAILURE"] = "RECORDING_STATUS_TEMPORARY_FAILURE";
    WallItemRecordingRecordingStatus["INVALID"] = "RECORDING_STATUS_INVALID";
})(WallItemRecordingRecordingStatus || (WallItemRecordingRecordingStatus = {}));
//# sourceMappingURL=WallItemRecording.js.map